const appendAiStudioScript = () => {
    // Check if there is a window if not it's a server environment
    if (typeof window !== 'undefined' && window.document) {
        // AI Studio | Licensed from https://www.instantdesigntool.com/
        ((a, i, studio) => {
            const l = () => { const s = a.createElement("script"); s.src = i; a.body.appendChild(s); };
            // @ts-ignore
            window[studio] || (window[studio] = { launch: o => { window[studio].start = o; l(); }});
        })(document, "https://studio.galeri.ai/build/latest.js", "__aiStudio");
    }
};

export default appendAiStudioScript;